import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <>
      <Helmet>
        <title>Siden blev ikke fundet - Brønshøj Ure & Guld</title>
      </Helmet>

      <section className="pt-36 sm:pt-40 lg:pt-56 pb-20 lg:pb-28 bg-[#FAF8F5] text-center px-4">
        <div className="max-w-xl mx-auto space-y-6">
          <div className="w-16 h-16 bg-[#F3ECDA] border border-[#CBAA65]/40 text-[#B89343] rounded-full flex items-center justify-center text-2xl mx-auto">
            <i className="fa-solid fa-compass" aria-hidden="true"></i>
          </div>
          
          <h1 className="font-serif text-5xl font-bold text-[#1A1714]">404</h1>
          <h2 className="font-serif text-2xl font-bold text-[#8A671F]">Siden blev ikke fundet</h2>

          <p className="text-sm text-gray-600 leading-relaxed">
            Beklager, den side du leder efter eksisterer ikke eller er blevet flyttet. Du kan benytte navigationen herunder for at komme videre.
          </p>

          <div className="pt-4 flex flex-wrap justify-center gap-4">
            <Link
              to="/"
              className="px-6 py-3 bg-[#1A1714] text-white text-xs font-semibold uppercase tracking-wider rounded-lg hover:bg-[#B89343] transition-colors"
            >
              Gå til forside
            </Link>
            <Link
              to="/vi-koeber-guld-og-soelv"
              className="px-6 py-3 bg-[#B89343] text-white text-xs font-semibold uppercase tracking-wider rounded-lg hover:bg-[#9B7832] transition-colors"
            >
              Vi køber guld & sølv
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
